<template>
    <label class="checkcontainer m-2 inline relative cursor-pointer">{{ text }}
        <input :name="name" type="radio" @focus="active = true" @blur="active = false" :value="value" :checked="value === model"
               @change="e => $emit('change', value)"/>
        <div class="radiobtn" :class="{'active': active, 'color-error-border': this.error}"></div>
    </label>
</template>
<script>
export default {
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        text: String,
        name: String,
        value: [Object, Number, String],
        model: [Object, Number, String],
        error: Boolean
    },
    data() {
        return {
            active: false
        }
    }
};
</script>
<style lang="scss" scoped>

$border: 1px;
$outer: 16px;
$inner: 10px;

.checkcontainer {
    padding-left: $outer + 6px;

    user-select: none;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
}

.radiobtn {
    position: absolute;
    top: 0;
    left: 0;
    height: $outer;
    width: $outer;

    background-color: #fff;
    border-radius: 50%;
    border: $border solid #429ed6;

    &.active {
        box-shadow: 2px 2px 4px 1px #999;
    }
}

.checkcontainer:hover input ~ .radiobtn:after {
    background-color: #ccc;
}

.checkcontainer input:checked ~ .radiobtn:after {
    background-color: #1a3989;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radiobtn:after {
    content: "";
    position: absolute;
    width: $inner;
    height: $inner;
    left: ($outer - $inner - $border - $border) / 2;
    top: ($outer - $inner - $border - $border) / 2;
    border-radius: 50%;
    background-color: #fff;
}


/* Show the indicator (dot/circle) when checked */
.checkcontainer input:checked ~ .radiobtn:after {
    display: block;
}

</style>


